import { z } from 'zod'

export const productTagSchema = z.object({
  code: z.enum([
    'NowLowest', // 지금할인
    'AllTimeLowest', // 역대최저
    'MonthLowest', // 이번달최저
    'EyeFocus', // 시선집중
    'Toksopic', // 똑소픽
    'TodayLowest', // 오늘최저
    'TomorrowLowest', // 내일최저
    'ManwonHappinessFood', // 만원행복식품
    'ManwonHappinessLife', // 만원행복생활
    'HotDeal', // ??
    'WeekBest', // ??
    'MonthBest', // ??
    'New', // ??
  ]),
  name: z.string(),
  isVisible: z.boolean(),
})

export type ProductTag = z.infer<typeof productTagSchema>
